<template>
  <div class="constructing-page">
    <div style="color: red"><i class="fa fa-bolt"/></div>
    <div style="margin-left:20px;color: rgb(52, 78, 117)">This page is under construction!</div>
  </div>
</template>

<script>
export default {
  name: 'ConstructingPage',
};
</script>

<style scoped>
  .constructing-page {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 40px;
    justify-content: center;
  }
</style>
